import React from 'react';
import {updatePersonalInfoEditMode} from '../../redux/app-state-slice';
import {EditButton} from './EditButton';

export function EditPersonalInfoButton({customerData, dispatch}) {
  const onClickHandler = () => dispatch(updatePersonalInfoEditMode(true));

  return (
    <EditButton
      testId='editPersonalInfo'
      onClick={onClickHandler}
      disabled={
        customerData.cardEditFlags.residenceEditMode.value ||
        customerData.cardEditFlags.incomeEditMode.value ||
        customerData.cardEditFlags.vehicleEditMode.value
      }
    />
  );
}
